import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import moment from "moment";
import ReactSelect from "react-select";
import { Modal, Col } from "react-bootstrap";
// import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';
// import BlockSharpIcon from "@mui/icons-material/BlockSharp";
// import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
// import ClearSharpIcon from "@mui/icons-material/ClearSharp";
// import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
// import DoneIcon from "@mui/icons-material/Done";
// import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import DeleteIcon from '@mui/icons-material/Delete';
import { customStyles } from "../../selectStyles";

const TestAssign = () => {
    const sessionId = localStorage.getItem("sessionId");
    const [currentPage, setCurrentPage] = useState(1);
    const [interviewData, setInterviewData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [totalRows, setTotalRows] = useState(1);
    const [interviewType, setInterviewType] = useState("Candidate");
    const [unAuthorizeError, setUnAuthorizeError] = useState("");

    const [unauthModal, setUnauthModal] = useState(false);
    const handleunauthModal = () => setUnauthModal(true);
    const handlecloseunauthModal = () => setUnauthModal(false);



    const handleTabChange = (tab) => {
        const type = tab === 2 ? "InsttCandidate" : "Candidate";

        setInterviewType(prevType => {
            return type;
        });
        getInterviewShedule(1, type);
        // const filteredData = originalCandidateList.filter(item => item.type === type);
        // setCandidateList(filteredData);
    };

    useEffect(() => {
        if (interviewType) {
            getInterviewShedule(currentPage, interviewType);
        }
    }, [interviewType]); 

useEffect(() => {
    if (interviewType) {
        getInterviewShedule(currentPage, interviewType);
    }
}, [currentPage]);

    const getInterviewShedule = async (page, type) => {
        if (!type) {
            return;
        }
        try {
            const requestBody = {
                sessionId: sessionId,
                pageNumber: page,
                pageSize: 5,
            };

            axios
                .post(`JobApplication/GetAllAssignedTest?CnddtType=${type}`, requestBody)
                .then((response) => {
                    const res = response?.data?.responseData?.candidateTestInfoList || [];
                    if (!res?.allJobInterviews?.length) {
                        console.warn(` No data found for type: ${type}`);

                    }
                    setInterviewData(res);
                    setTotalRows(response?.data?.responseData?.paging?.totalrecords || 0);
                    setIsLoading(false);

                    setIsError(res.length === 0);
                })
                .catch((err) => {
                    console.error("Error fetching jobs:", err);
                    setIsError(true); // Handle error state
                    setIsLoading(false);
                    if (err.response && err.response.status === 409) {
                        // toast.error(err.response.data.message);
                        console.error("Unexpected error:", err);
                        setUnAuthorizeError(err.response.data.message)
                        handleunauthModal()
                    } else {
                        console.error("Unexpected error:", err);

                    }
                });

        } catch (error) {
            console.error("API Error:", error);
            setIsError(true);
        }
    };

    const tabStyle = (isActive) => ({
        cursor: "pointer",
        //   width: "100px", 
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        border: "none", // Removes all borders
        borderBottom: isActive ? "3px solid #feaa00" : "none", // Keeps only the bottom border
        backgroundColor: "transparent", // Ensures no background interference
    });


    useEffect(() => {
        // getInterviewShedule(currentPage);
    }, [interviewType, currentPage]);

    const [candidateInfo, setCandidateInfo] = useState(null);
    const [instCandidateInfo, setInstCandidateInfo] = useState(null);

    const TestInfo = async (testid, id, cndId) => {
        console.log("testinfo===>", testid, id);

        const data = {
            sessionId: sessionId,
            jbApplctnId: id,
            cnddtID: cndId,
            cnddtType: interviewType,
            testID: testid
        };
        console.log("data===>", data);

        try {
            await axios.post("/JobApplication/GetAssignedTestInfo", data).then((resData) => {
                console.log("HISTORY", resData.data.responseData);
                const data1 = resData.data.responseData;
                console.log("data1", data1);
                setCandidateInfo(data1);
                // setInstCandidateInfo(data1)
            });
        } catch (e) {
            console.log("Unapply ");
        }
    };

    const TestInfoInst = async (testid, id, cndId) => {
        console.log("testinfo===>", testid, id);

        const data = {
            sessionId: sessionId,
            jbApplctnId: id,
            cnddtID: cndId,
            cnddtType: interviewType,
            testID: testid
        };
        console.log("data===>", data);

        try {
            await axios.post("/JobApplication/GetAssignedTestInfo", data).then((resData) => {
                console.log("HISTORY", resData.data.responseData);
                const data1 = resData.data.responseData;
                console.log("data1", data1);
                setInstCandidateInfo(data1)
                 handleInstTestShow();
            });
        } catch (e) {
            console.log("Unapply ");
        }
    };


    // ..............................................Test Assign actions.................................................................


    const [testRemark, setTestRemark] = useState("");
    const [testName, setTestName] = useState("");

    const [testType, setTestType] = useState("");
    const [testTypeList, setTestTypeList] = useState([]);
    const [testLink, setTestLink] = useState("");
    const [platFormList, setPlatFormList] = useState([])
    const [platform, setPlatform] = useState(null);
    const [testDuration, setTestDuration] = useState(null);
    const [testSchedule, setTestSchedule] = useState("");
    const [testInstruction, setTestInstruction] = useState("");

    const [insttestRemark, setInstTestRemark] = useState("");
    const [insttestName, setInstTestName] = useState("");

    const [insttestType, setInstTestType] = useState("");
    const [insttestTypeList, setInstTestTypeList] = useState([]);
    const [insttestLink, setInstTestLink] = useState("");
    const [instplatFormList, setInstPlatFormList] = useState([])
    const [instplatform, setInstPlatform] = useState(null);
    const [insttestDuration, setInstTestDuration] = useState(null);
    const [insttestSchedule, setInstTestSchedule] = useState("");
    const [insttestInstruction, setInstTestInstruction] = useState("");
    const [jobappId, setjobappId] = useState(null);
    // const [jobappNameId, setjobappNameId] = useState("");
    const [testId, setTestId] = useState(null);
    const [insttestId, setInstTestId] = useState(null);


    const getTestTypeList = async () => {
        try {
            const response = await axios.get(`/MasterDDL/GetCandidateAssignTestTypesDDL`)
            //   console.log("GetList==>",response)
            const TestTypeOption = response.data.responseData.map((val) => ({
                value: val.id,
                label: val.name,
            }));
            setTestTypeList(TestTypeOption)
        }
        catch (error) {
            console.log("GetList==>", error);
        }
    }

    const handleTestType = (selectedOption) => {
        console.log("Selected Test Type", selectedOption);
        setTestType(selectedOption.value); // Dropdown options clear karein
        console.log("Selected Test Type:", selectedOption.value);
    };

    const handleTestTypeInst = (selectedOption) => {
        console.log("Selected Test Type", selectedOption);
        setInstTestType(selectedOption.value); // Dropdown options clear karein
        console.log("Selected Test Type:", selectedOption.value);
    };

    const getplatformList = async () => {
        try {
            const response = await axios.get(`/MasterDDL/GetOnlineProctoringPlatformDDL`)
            console.log("platform==>", response)
            const platformOption = response.data.responseData.map((val) => ({
                value: val.id,
                label: val.name,
            }));
            setPlatFormList(platformOption)
        }
        catch (error) {
            console.log("GetList==>", error);
        }
    }

    const handlePlatform = (selectedOption) => {
        setPlatform(selectedOption.value);
    };
    const handleInstPlatform = (selectedOption) => {
        setInstPlatform(selectedOption.value);
    };


    useEffect(() => {
        getTestTypeList();
        getplatformList();
    }, [])

    const [showtestModal, setShowTestModal] = useState(false);
    const [showInsttTestModa, setInstTestModal] = useState(false)

    const handleTestShow = () => setShowTestModal(true);
    const handleCloseTestModal = () => setShowTestModal(false);

    const handleInstTestShow = () => setInstTestModal(true)
    const handleInstTestClose = () => setInstTestModal(false);

    const UpdateTestAsign = async () => {
        if (!testName && !testType && !testDuration && !testSchedule && !platform && !testLink)
            return toast.error("Please fill all required fields");

        try {
            const urlPattern = /^(https?:\/\/)?([\w\d.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/.*)?$/;
            if (!urlPattern.test(testLink)) {
                toast.error("Please enter a valid Test Link!");
                return;
            }
            const requestBody = {
                sessionId: sessionId,
                jbApplctnId: jobappId,
                cnddtID: null,
                cnddtType: interviewType === "Candidate" ? "Candidate" : "InsttCandidate",
                testName: testName,
                testType: testType,
                testDurationMinutes: testDuration,
                scheduledAt: testSchedule,
                platform: platform,
                link: testLink,
                testInstructions: testInstruction,
                remark: testRemark,
                testID: testId,
            };
            console.log("testdetail", requestBody);
            const response = await axios.post(
                "/JobApplication/UpdateAssignTestToCandidate",
                requestBody
            );
            toast.success(response.data.message)
            getInterviewShedule(1, "Candidate");
            handleCloseTestModal();
            setTestType("");
            setTestName("");
            setTestRemark("");
            setTestInstruction("");
            setTestDuration(null);
            setTestSchedule("");
            setPlatform(null);
            setTestLink("");
        } catch (error) {
            toast.error(error.response.data.message);
            handleCloseTestModal();

            // toast.error("Some problem occurred!");
            console.error("API Error:", error);
        }
    };

    const UpdateTestAsignInsCandid = async () => {
        if (!insttestName && !insttestType && !insttestDuration && !insttestSchedule && !instplatform && !insttestLink)
            return toast.error("Please fill all required fields");

        const urlPattern = /^(https?:\/\/)?([\w\d.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/.*)?$/;

        if (!urlPattern.test(insttestLink)) {
            toast.error("Please enter a valid Test Link!");
            return;
        }
        try {

            const requestBody = {
                sessionId: sessionId,
                jbApplctnId: instjobappId,
                cnddtID: candidateId,
                cnddtType: interviewType,
                testName: insttestName,
                testType: insttestType,
                testDurationMinutes: insttestDuration,
                scheduledAt: insttestSchedule,
                platform: instplatform,
                link: insttestLink,
                testInstructions: insttestInstruction,
                remark: insttestRemark,
                testID: insttestId
            };
            console.log("testdetail====111", requestBody);

            const response = await axios.post(
                "/JobApplication/UpdateAssignTestToCandidate",
                requestBody
            );

            toast.success(response.data.message)
            getInterviewShedule(1, "InsttCandidate");

            handleInstTestClose();
            setTestType("");
            setTestName("");
            setTestRemark("");
            setTestInstruction("");
            setTestDuration(null);
            setTestSchedule("");
            setPlatform(null);
            setTestLink("");
        } catch (error) {
            toast.error(error.response.data.message);
            handleInstTestClose();

            // toast.error("Some problem occurred!");
            console.error("API Error:", error);
        }
    };


    // const [open, setOpen] = useState(false);

    // const handleOpen = () => setOpen(true);
    // const handleCloseTest = () => setOpen(false);


    // const handleTestInfoShow = async (row) => {
    //     console.log("Oen Edit MOdal==>",row)
    //     setjobappId(row?.jbApplctnId);
    //     setTestId(row?.testID);

    //     await TestInfo(row?.jbApplctnId);
    //     handleTestShow();
    // };


    // ...........detele test .................

    const [showDeletetestModal, setDeleteTestModal] = useState(false);
    const handleTestDeleteShow = () => setDeleteTestModal(true);
    const handleCloseDeleteTestModal = () => setDeleteTestModal(false);

    const TestDelete = async () => {
        try {
            const requestBody = {
                sessionId: sessionId,
                jbApplctnId: jobappId,
                cnddtID: candidateId ? candidateId : null,
                cnddtType: interviewType === "Candidate" ? "Candidate" : "InsttCandidate",
                testID: testId,
                delete: true,
                status: null
            };
            console.log("testdetail", requestBody);

            const response = await axios.post(
                "/JobApplication/AssignedTestAction",
                requestBody
            );

            toast.success(response.data.message)
            getInterviewShedule(1, "Candidate");

            handleCloseDeleteTestModal();

        } catch (error) {
            toast.error(error.response.data.message);
            handleCloseDeleteTestModal();

        }
    };

    const TestDeleteInsCandi = async () => {
        try {
            const requestBody = {
                sessionId: sessionId,
                jbApplctnId: instjobappId,
                cnddtID: candidateId ? candidateId : null,
                cnddtType: interviewType,
                testID: insttestId,
                delete: true,
                status: null
            };
            console.log("testdetail", requestBody);

            const response = await axios.post(
                "/JobApplication/AssignedTestAction",
                requestBody
            );

            toast.success(response.data.message)
            getInterviewShedule(1, "InsttCandidate");

            handleCloseDeleteTestModal();

        } catch (error) {
            toast.error(error.response.data.message);
            handleCloseDeleteTestModal();

        }
    };
    // get assined candidate data   

    useEffect(() => {
        if (candidateInfo) {
            setTestName(candidateInfo?.testName);
            setTestLink(candidateInfo?.link);
            setTestDuration(candidateInfo?.testDurationMinutes);
            // setTestSchedule(candidateInfo?.scheduledAt);\
            const localMoment = moment.utc(candidateInfo?.scheduledAt).local();
            setTestSchedule(localMoment.format("YYYY-MM-DDTHH:mm"));
            setTestRemark(candidateInfo?.remark);
            setTestInstruction(candidateInfo?.testInstructions);
            setTestType(candidateInfo?.testType);
            setPlatform(candidateInfo?.platform)

        }
    }, [candidateInfo, showtestModal]);
    console.log("institute candidate info===>", instCandidateInfo)
    useEffect(() => {
        if (instCandidateInfo) {
            setInstTestName(instCandidateInfo?.testName);
            setInstTestLink(instCandidateInfo?.link);
            setInstTestDuration(instCandidateInfo?.testDurationMinutes);
            // setInstTestSchedule(instCandidateInfo?.scheduledAt);
            // setInstTestSchedule(instCandidateInfo?.scheduledAt);
            const localMoment = moment.utc(instCandidateInfo?.scheduledAt).local();
			setInstTestSchedule(localMoment.format("YYYY-MM-DDTHH:mm"));
            setInstTestRemark(instCandidateInfo?.remark);
            setInstTestInstruction(instCandidateInfo?.testInstructions);
            setInstTestType(instCandidateInfo?.testType);
            setInstPlatform(instCandidateInfo?.platform)
            //setCandidateId(candidateInfo?.cnddtID)
        }
    }, [instCandidateInfo, showInsttTestModa]);

    //   Columns
    const columns = [
        {
            name: "ASSIGN DATE",
            center: true,
            sortable: true,
            minWidth: "150px",
            //   selector: (row) => row.jbApplctnTypeName,
            cell: (row) => (
                <>
                    <div className="d-flex">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <div className="">
                                <div className="month text-center">
                                    {" "}
                                    {moment(row.scheduledAt).format("MMM YYYY").toUpperCase()}
                                </div>
                                <div className="day text-center"> {moment(row.scheduledAt).format("DD")}</div>
                            </div>
                            <p className="mb-1 mt-2"><span className="f-600">Time : </span>{moment.utc(row.scheduledAt).local().format("hh : mm A")}</p>
                        </div>
                    </div>
                </>
            ),
        },
        {
            name: "TEST DETAILS",
            // center: true,
            sortable: true,
            minWidth: "200px",
            cell: (row) => (
                <>
                    <div
                        className="pt-2 pb-2"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {row.testName === "" ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test : </span>{row.testName}</p>
                        </>)}
                        {row.testDurationMinutes === null ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test Duration : </span>{row.testDurationMinutes} Minutes</p>
                        </>)}
                        {row.remark === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Remark : </span> {row.remark}</p>
                        </>)}
                        {row.platform === "" ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Platform : </span> {platFormList.find(
                                (platform) => platform.value === row.platform
                            )?.label || row.platform}</p>
                        </>)}
                        {row.link === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Link : </span> {row.link}</p>
                        </>)}
                        {row.testInstructions === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Instruction : </span> {row.testInstructions}</p>
                        </>
                        )}

                    </div>
                </>
            ),
        },
        {
            name: "CANDIDATES",
            sortable: true,
            center: true,
            cell: (row) => (
                <div className="mt-2 mb-2" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>

                    <div className="AssignCandid"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",

                        }}
                    >
                        <img
                            src={row?.cnddtProfilePic}
                            alt="User"
                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                        <div className="f-600 mt-1 user">
                            <Link
                                to={`/Candidate/${row.cnddtUid}`}>
                                {row.cnddtName}
                            </Link>
                        </div>
                        <div className="f-600 mt-1 text-center">
                            <Link
                                to={`/job/${row?.jobID}`}
                                className=" "  >
                                {row?.jobTitle}
                            </Link>

                        </div>

                    </div>


                </div>
            ),
        },
        {
            name: "Action",
            center: true,
            sortable: true,
            minWidth: "150px",
            cell: (row) => (
                <>
                    <div className="d-block">
                        <span className="ms-2 ">
                            <Tooltip title="Update Assign Test" arrow>

                                <EditIcon
                                    onClick={() => {
                                        // handleTestInfoShow(row)
                                        handleTestShow();
                                        TestInfo(row?.testID, row?.jbApplctnId, row.cnddtID);
                                        setjobappId(row?.jbApplctnId);
                                        setTestId(row?.testID);
                                    }}
                                    className="blueIcon" />
                            </Tooltip>
                        </span>


                        <span>
                            <Tooltip title="Delete Test" arrow>
                                <DeleteIcon
                                    className="pointer rejectIcon"
                                    onClick={() => {
                                        handleTestDeleteShow();
                                        setjobappId(row?.jbApplctnId);
                                        setTestId(row?.testID);
                                        setCandidateId(row?.cnddtID);
                                    }}

                                />
                            </Tooltip>
                        </span>
                        {/* <span className="ms-2 ">
                            <Tooltip title="Test Info" arrow>
                                <VisibilitySharpIcon className="ViewIcon"
                                    onClick={() => {
                                        handleTestInfoShow(row);
                                        // setjobappId(row?.jbApplctnId);
                                        // setTestId(row?.testID);
                                    }}
                                />
                            </Tooltip>
                        </span> */}

                    </div>


                </>
            ),
        },
    ];

    const [updateRemark, setUpdateRemark] = useState("");
    const [intrvwId, setintrvwId] = useState("");
    const [candidateId, setCandidateId] = useState();
    const [instjobappId, setInstjobappId] = useState(null);
    console.log("Candidate ID==>", candidateId)
    //   Institute Columns

    const Inscolumns = [
        {
            name: "ASSIGN DATE",
            center: true,
            sortable: true,
            minWidth: "150px",
            //   selector: (row) => row.jbApplctnTypeName,
            cell: (row) => (
                <>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <div className="date-box">
                            <div className="month text-center">
                                {" "}
                                {moment(row.scheduledAt).format("MMM YYYY").toUpperCase()}
                                {/* {moment.utc(row.scheduledAt).local().format("MMM YYYY")} */}
                            </div>
                            <div className="day text-center"> {moment(row.scheduledAt).format("DD")}</div>
                        </div>
                        <p className="mb-1 mt-2"><span className="f-600">Time : </span>{moment.utc(row.scheduledAt).local().format("hh : mm  A")} </p>
                        {/* <p className="mb-1 mt-2"><span className="f-600">Time : </span>{moment(row.scheduleTime).format("HH : mm  A")} </p> */}
                    </div>
                </>
            ),
        },
        // {
        //     name: "TEST DETAILS",
        //     center: true,
        //     sortable: true,
        //     cell: (row) => {
        //         // Find the platform name based on the ID
        //         const platformName = platFormList.find(
        //             (platform) => platform.value === row.platform
        //         )?.label;

        //         return (
        //             <>
        //                 <div
        //                     className="pb-2 pt-2"
        //                     style={{
        //                         display: "flex",
        //                         flexDirection: "column",
        //                     }}
        //                 >
        //                     {row.testName === "" ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Test : </span>
        //                             {row.testName}
        //                         </p>
        //                     )}
        //                     {row.testDurationMinutes === null ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Test Duration : </span>
        //                             {row.testDurationMinutes} Minutes
        //                         </p>
        //                     )}
        //                     {row.remark === "" || row.remark === null ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Remark : </span>
        //                             {row.remark}
        //                         </p>
        //                     )}
        //                     {row.platform === "" || row.platform === null ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Platform : </span>
        //                             {platformName || row.platform}
        //                         </p>
        //                     )}
        //                     {row.link === "" || row.link === null ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Link : </span>
        //                             {row.link}
        //                         </p>
        //                     )}
        //                     {row.testInstructions === "" || row.testInstructions === null ? null : (
        //                         <p className="mb-1">
        //                             <span className="f-600">Instruction : </span>
        //                             {row.testInstructions}
        //                         </p>
        //                     )}
        //                 </div>
        //             </>
        //         );
        //     },
        // },
        {
            name: "TEST DETAILS",
            // center: true,
            sortable: true,
            minWidth: "200px",
            cell: (row) => (
                <>
                    <div
                        className="pt-2 pb-2"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {row.testName === "" ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test : </span>{row.testName}</p>
                        </>)}
                        {row.testDurationMinutes === null ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test Duration : </span>{row.testDurationMinutes} Minutes</p>
                        </>)}
                        {row.remark === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Remark : </span> {row.remark}</p>
                        </>)}
                        {row.platform === "" ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Platform : </span> {platFormList.find(
                                (platform) => platform.value === row.platform
                            )?.label || row.platform}</p>
                        </>)}
                        {row.link === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Link : </span> {row.link}</p>
                        </>)}
                        {row.testInstructions === null ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Instruction : </span> {row.testInstructions}</p>
                        </>
                        )}

                    </div>
                </>
            ),
        },
        {
            name: "CANDIDATES",
            sortable: true,
            center: true,
            cell: (row) => (
                <div className="mt-2 mb-2" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>

                    <div className="AssignCandid"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",

                        }}
                    >
                        <img
                            src={row?.cnddtProfilePic}
                            alt="User"
                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                        <div className="f-600 mt-1 user">
                            <Link
                                to={`/Candidate/${row.cnddtUid}`}>
                                {row.cnddtName}
                            </Link>
                        </div>
                        <div className="f-600 mt-1 text-center">
                            <Link
                                to={`/job/${row?.jobID}`}
                                className=""  >
                                {row?.jobTitle}
                            </Link>

                        </div>
                        <div className="job-footer-left mt-1">
                            <ul className="" style={{ margin: 0, padding: 0 }}>

                                <Link
                                    to={`/Institution/${row?.candidateInsttInfo?.insttUID}`}>
                                    <li className="mb-0">
                                        {row?.candidateInsttInfo?.insttName}
                                    </li>
                                </Link>
                            </ul>
                        </div>


                    </div>


                </div>
            ),
        },
        {
            name: "Action",
            center: true,
            sortable: true,
            minWidth: "150px",
            cell: (row) => (
                <>
                    <div className="d-block">
                        <span className="ms-2 ">
                            <Tooltip title="Update Assign Test" arrow>

                                <EditIcon
                                    onClick={() => {
                                        //handleInstTestShow();
                                        setCandidateId(row?.cnddtID);
                                        TestInfoInst(row?.testID, row?.jbApplctnId, row.cnddtID);
                                        setInstjobappId(row?.jbApplctnId);
                                        setInstTestId(row?.testID);

                                    }}
                                    className="blueIcon" />
                            </Tooltip>
                        </span>

                        <span>
                            <Tooltip title="Delete Test" arrow>
                                <DeleteIcon
                                    className="pointer rejectIcon"
                                    onClick={() => {
                                        handleTestDeleteShow();
                                        setInstjobappId(row?.jbApplctnId);
                                        setInstTestId(row?.testID);
                                        setCandidateId(row?.cnddtID);
                                    }}

                                />
                            </Tooltip>
                        </span>
                        {/* <span className="ms-2 ">
                            <Tooltip title="Test Info" arrow>

                                <VisibilitySharpIcon className="ViewIcon"
                                    onClick={() => {
                                        handleTestInfoShow(row)
                                    }}
                                />
                            </Tooltip>
                        </span> */}

                    </div>


                </>
            ),
        },

    ]

    // const handleChange = (e) => {
    //     let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    //     if (value.length <= 2) {
    //         // 2-digit or less → Only minutes
    //         setTestDuration(value);
    //     } else if (value.length === 3) {
    //         // 3-digit → Convert to H:MM format
    //         const hours = value[0];
    //         const minutes = value.slice(1);
    //         setTestDuration(`${hours}:${minutes}`);
    //     } else if (value.length === 4) {
    //         // 4-digit → Convert to HH:MM format
    //         const hours = value.slice(0, 2);
    //         const minutes = value.slice(2);
    //         setTestDuration(`${hours}:${minutes}`);
    //     }
    // };

    return (
        <>
            <section className="pricing-section-three container jobapplication interviews application-drop-section">
                <div className="row">
                    <div className="delete-title mb-1 col-6">
                        <h1 className="orange-title">
                            <span className="orange-box me-2"></span>
                            Assign Test
                        </h1>
                    </div>
                    <div className="mb-1 col-6 text-start"></div>
                </div>
                <div className="container st3">

                    <div className="tabButton d-flex w-100 ps-0 connectionTab mb-2">

                        <button
                            onClick={() => handleTabChange(1)}
                            style={tabStyle(interviewType === "Candidate")}
                        >
                            Candidate
                        </button>
                        <button
                            onClick={() => handleTabChange(2)}
                            style={tabStyle(interviewType === "InsttCandidate")}
                        >
                            Institution
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* <div className="manage-batches-container">
								<h2 className="manage-heading">{interviewType} List</h2>
							</div> */}
                            {isLoading ? (
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <ShimmerDiv mode="light" height={100} width={'100%'} />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <ShimmerDiv mode="light" height={100} width={'100%'} />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <ShimmerDiv mode="light" height={100} width={'100%'} />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <ShimmerDiv mode="light" height={100} width={'100%'} />
                                    </div>
                                </div>
                            ) : isError ? (
                                <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                    <img src={error} alt="404 Not Found" width={300} />
                                    {/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
                                </div>

                            ) : interviewData.length === 0 && (interviewType === "InsttCandidate" || interviewType === "Candidate") ? (
                                <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                    <img src={error} alt="404 Not Found" width={300} />
                                </div>
                            ) : (
                                <>
                                    {interviewType === "Candidate" ? (
                                        <>
                                            <div className="table-res">
                                                <div className="react-dataTable react-table-colorclass">
                                                    <DataTable
                                                        noHeader
                                                        pagination
                                                        columns={columns}
                                                        data={interviewData}
                                                        progressPending={isLoading}
                                                        paginationServer
                                                        paginationPerPage={5}
                                                        paginationTotalRows={totalRows}
                                                        paginationRowsPerPageOptions={[]}
                                                        onChangePage={(page) => {
                                                            setCurrentPage(page); // Update the current page
                                                        }}
                                                        sortIcon={<ChevronDown size={10} />}
                                                        className="react-dataTable"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="table-res">
                                                <div className="react-dataTable react-table-colorclass">
                                                    <DataTable
                                                        noHeader
                                                        pagination
                                                        columns={Inscolumns}
                                                        // columns={columns}
                                                        data={interviewData}
                                                        progressPending={isLoading}
                                                        paginationServer
                                                        paginationPerPage={5}
                                                        paginationTotalRows={totalRows}
                                                        paginationRowsPerPageOptions={[]}
                                                        onChangePage={(page) => {
                                                            setCurrentPage(page); // Update the current page
                                                        }}
                                                        sortIcon={<ChevronDown size={10} />}
                                                        className="react-dataTable"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </section>




            {/*.................................... Test Assign Modal End ................................*/}

            <Modal show={showtestModal} onHide={handleCloseTestModal} centered size="lg">
                <Modal.Header>
                    <Modal.Title>Update Assign Test</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseTestModal} />
                </Modal.Header>
                <Modal.Body>

                    <div className="row  mt-2 align-center">

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Name<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Name"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testName}
                                    onChange={(e) => setTestName(e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group text-transform-email">
                                <label htmlFor="about" className="f-14 f-700">
                                    Link<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Link"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testLink}
                                    onChange={(e) => setTestLink(e.target.value)}
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Type<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>

                                <ReactSelect
                                    options={testTypeList}
                                    onChange={handleTestType} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Test Type"
                                    value={testTypeList.find(option => option.value === testType) || null}
                                    classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Platform<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <ReactSelect
                                    options={platFormList}
                                    onChange={handlePlatform} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Platform"
                                    value={platFormList.find(option => option.value === platform) || null} classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>


                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Duration Minutes<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Duration "
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testDuration}
                                    onChange={(e) => setTestDuration(e.target.value)}
                                // onChange={handleChange}

                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about">
                                    Schedule Time<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <Flatpickr
                                    data-enable-time
                                    value={testSchedule}
                                    onChange={(selectedDates) => {
                                        setTestSchedule(selectedDates[0], "testSchedule");
                                    }}
                                    options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i",
                                        minDate: new Date(),
                                        static: true, // Keeps the calendar visible on click         
                                    }}
                                    className="form-control Dark-Input-from-group"
                                    placeholder="Enter schedule time"
                                />
                            </div>
                        </Col>
                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Remark
                                </label>
                                <textarea
                                    placeholder="Enter Remark"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testRemark}
                                    onChange={(e) => setTestRemark(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                    <div className="row">

                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Instructions
                                </label>
                                <textarea
                                    placeholder="Enter Instruction"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testInstruction}
                                    onChange={(e) => setTestInstruction(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn khojPrimaryBtn test-assign-khojPrimaryBtn"
                        // onClick={() => {
                        //     UpdateTestAsign();
                        // }}
                        onClick={() => {

                            UpdateTestAsign();

                        }}
                    >
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showInsttTestModa} onHide={handleInstTestClose} centered size="lg">
                <Modal.Header>
                    <Modal.Title>Update Assign Test</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleInstTestClose} />
                </Modal.Header>
                <Modal.Body>

                    <div className="row  mt-2 align-center">

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Name<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Name"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={insttestName}
                                    onChange={(e) => setInstTestName(e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group text-transform-email">
                                <label htmlFor="about" className="f-14 f-700">
                                    Link<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Link"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={insttestLink}
                                    onChange={(e) => setInstTestLink(e.target.value)}
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Type<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>

                                <ReactSelect
                                    options={testTypeList}
                                    onChange={handleTestTypeInst} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Test Type"
                                    value={testTypeList.find(option => option.value === insttestType) || null}
                                    classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Platform<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <ReactSelect
                                    options={platFormList}
                                    onChange={handleInstPlatform} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Platform"
                                    value={platFormList.find(option => option.value === instplatform) || null} classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>


                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Duration Minutes<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Duration "
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={insttestDuration}
                                    onChange={(e) => setInstTestDuration(e.target.value)}
                                // onChange={handleChange}

                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about">
                                    Schedule Time<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <Flatpickr
                                    data-enable-time
                                    value={insttestSchedule}
                                    onChange={(selectedDates) => {
                                        setInstTestSchedule(selectedDates[0]);
                                    }}
                                    options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i",
                                        minDate: new Date(),
                                        static: true, // Keeps the calendar visible on click         
                                    }}
                                    className="form-control Dark-Input-from-group"
                                    placeholder="Enter schedule time"
                                />
                            </div>
                        </Col>
                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Remark
                                </label>
                                <textarea
                                    placeholder="Enter Remark"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={insttestRemark}
                                    onChange={(e) => setInstTestRemark(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                    <div className="row">

                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Instructions
                                </label>
                                <textarea
                                    placeholder="Enter Instruction"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={insttestInstruction}
                                    onChange={(e) => setInstTestInstruction(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn khojPrimaryBtn test-assign-khojPrimaryBtn"
                        // onClick={() => {
                        //     UpdateTestAsign();
                        // }}
                        onClick={() => {

                            UpdateTestAsignInsCandid();

                        }}
                    >
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>

            {/*.................................... Test Info ................................*/}

            {/* ...............UnAuthorize modal............  */}
            {unAuthorizeError ? (
                <Modal show={unauthModal} centered>
                    <Modal.Header>
                        <Modal.Title>Unauthorize session expired</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="settings">
                        <div className=" mb-3">
                            <p>{unAuthorizeError}</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Link
                            className="pointer"
                            to="/Login"
                            onClick={() => {
                                localStorage.removeItem("token"); // Remove authentication token
                                sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
                                localStorage.removeItem("Module");
                            }}
                        >
                            <button className="btn btn-danger ">Login</button>
                        </Link>
                        {/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

                    </Modal.Footer>

                </Modal>
            ) : (
                ""
            )}


            {/* {/.................................... delete test Modal end ................................/} */}

            <Modal show={showDeletetestModal} onHide={handleCloseDeleteTestModal} centered>
                <Modal.Header>
                    <Modal.Title>Confirm delete</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseDeleteTestModal} />
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>Are you sure you want to delete.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-danger"
                        // onClick={() => {
                        //     TestDelete()
                        // }}
                        onClick={() => {
                            if (interviewType === "Candidate") {
                                TestDelete();
                            } else {
                                TestDeleteInsCandi();
                            }
                        }}
                    >
                        Confirm
                    </button>
                </Modal.Footer>

            </Modal>
        </>
    );
};

export default TestAssign;
